export default __webpack_public_path__ + "static/es-map-65cf7e4e8e58e1b364c0efa411acceec.png";